var map = {
	"./Babo.jpeg": 9515,
	"./Black Dragon.webp": 7314,
	"./Bravo Cat.webp": 2092,
	"./Cipo Ape.jpeg": 3840,
	"./Comeo.webp": 2429,
	"./Crow Man.webp": 7187,
	"./Cute Panda.avif": 2497,
	"./Dalle Donkey.webp": 7746,
	"./Dashing Cat.webp": 2180,
	"./Demer Ape.webp": 7857,
	"./Fire Dragon.avif": 3565,
	"./Geo Monkey.png": 6422,
	"./Gromo Ape.webp": 1222,
	"./Inno Ape.webp": 1948,
	"./King Elephant.webp": 5232,
	"./Leo.webp": 504,
	"./Maji Ape.webp": 5019,
	"./Mico Dragon.webp": 8787,
	"./Miko Horse.webp": 9097,
	"./Muso Cat.webp": 1032,
	"./Panda Bear.avif": 5916,
	"./Parasa Horse.webp": 5263,
	"./Peri Lion.webp": 8052,
	"./Priso Ape.avif": 6873,
	"./Queen Ape.webp": 7726,
	"./Ropo Cat.webp": 8722,
	"./Sano Tiger.webp": 4868,
	"./Silo Elephant.webp": 1590,
	"./Soldo Ape.webp": 4583,
	"./Terif Giraffe.webp": 8896,
	"./Vizo Ape.webp": 9838,
	"./Winko Ape.webp": 9784,
	"./Xiler Ape.png": 4724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7791;